<div
  class="myField d-block"
>
  <h6 *ngIf="showLabel">{{label || displayText}}</h6>

  <div *ngIf="showValue">
    <p [ngSwitch]="dataType">
      <span *ngSwitchCase="'Boolean'">
          <span *ngIf="value"><i class="fa fa-check"></i>Yes</span>
          <span *ngIf="!value"><i class="fa fa-times"></i>No</span>
      </span>
      <span *ngSwitchDefault>{{value || '--'}}</span>
    </p>
  </div>
</div>